<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.deleted') }}</label></td>
      <td>{{ details.deleted_at  | time }}</td>
    </tr>

    <tr>
      <td><label>{{ $t('accountAssociations.details.account_id') }}</label></td>
      <td>
<!--        <router-link-->
<!--          :to="{name: 'account', params: {id: details.account_id, journey_id: details.id.String}}">-->
<!--          {{ details.account_id }}-->
<!--        </router-link>-->
        {{details.account_id}}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('accountAssociations.details.associated_account_id') }}</label></td>
      <td>
<!--        <router-link-->
<!--          :to="{name: 'account', params: {id: details.account_id, journey_id: details.id.String}}">-->
<!--          {{ details.associated_account_id }}-->
<!--        </router-link>-->
        {{details.associated_account_id}}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('accountAssociations.details.type') }}</label></td>
      <td>
<!--        <router-link-->
<!--          :to="{name: 'account', params: {id: details.account_id, journey_id: details.id.String}}">-->
<!--          {{ details.associated_account_id }}-->
<!--        </router-link>-->
        {{details.type}}
      </td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'associationDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
